import { GET_ZONE_MAPPING_FAILURE, GET_ZONE_MAPPING_REQUEST, GET_ZONE_MAPPING_REST, GET_ZONE_MAPPING_SUCCESS, } from "@/redux/actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const getZoneMappingReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_ZONE_MAPPING_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case GET_ZONE_MAPPING_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, error: null });
        case GET_ZONE_MAPPING_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        case GET_ZONE_MAPPING_REST:
            return Object.assign(Object.assign({}, state), { loading: false, data: null, error: null });
        default:
            return state;
    }
};
export default getZoneMappingReducer;
